import "../src/js/jquery";

import { addElementEvents } from "../src/js/utils/events";
import { addClass, hasClass } from "../src/js/utils/dom";
import Console from "../src/js/utils/log";

// import "../mobirise/theme-biogo/assets/web/assets/jquery/jquery.min.js";
import "../mobirise/theme-biogo/assets/popper/popper.min.js";
import "../mobirise/theme-biogo/assets/tether/tether.min.js";
import "../mobirise/theme-biogo/assets/bootstrap/js/bootstrap.min.js";
import "../mobirise/theme-biogo/assets/dropdown/js/nav-dropdown.js";
import "../mobirise/theme-biogo/assets/dropdown/js/navbar-dropdown.js";
import "../mobirise/theme-biogo/assets/touchswipe/jquery.touch-swipe.min.js";
// import "../mobirise/theme-biogo/assets/playervimeo/vimeo_player.js";
import "../mobirise/theme-biogo/assets/sociallikes/social-likes.js";
// import "../mobirise/theme-biogo/assets/parallax/jarallax.min.js";
import "../mobirise/theme-biogo/assets/parallax/parallax.min.js";
import "../mobirise/theme-biogo/assets/smoothscroll/smooth-scroll.js";
import "../mobirise/theme-biogo/assets/index.js";
import "../mobirise/theme-biogo/assets/slick.min.js";
import "../mobirise/theme-biogo/assets/theme/js/script.js";
// import "../mobirise/theme-biogo/assets/formoid/formoid.min.js";
// import "../mobirise/theme-biogo/assets/masonry/masonry.pkgd.min.js";
// import "../mobirise/theme-biogo/assets/imagesloaded/imagesloaded.pkgd.min.js";
// import "../mobirise/theme-biogo/assets/bootstrapcarouselswipe/bootstrap-carousel-swipe.js";
// import "../mobirise/theme-biogo/assets/vimeoplayer/jquery.mb.vimeo_player.js";
// import "../mobirise/theme-biogo/assets/slidervideo/script.js";
// import "../mobirise/theme-biogo/assets/gallery/player.min.js";
// import "../mobirise/theme-biogo/assets/gallery/script.js";

import "../src/js/blocks/container/styles.scss";
import "../src/js/blocks/claim/styles.scss";
import "../src/js/blocks/big-claim/styles.scss";
import "../src/js/blocks/video-cta/styles.scss";
import "../src/js/blocks/share/styles.scss";
import "../src/js/blocks/cta/styles.scss";
import "../src/js/blocks/posts/styles.scss";
import "../src/js/blocks/instagram-slider/styles.scss";
import "../src/js/blocks/pagination/styles.scss";
import "../src/js/blocks/block-quote/styles.scss";
import "../src/js/blocks/block-text-title/styles.scss";
import "../src/js/blocks/block-text-image/styles.scss";
import "../src/js/blocks/block-text-video/styles.scss";
import "../src/js/blocks/block-author/styles.scss";
import "../src/js/blocks/block-image-links-columns/styles.scss";

import "./styles.scss";

import initLozad from "../src/js/components/lozad";
import initContactForms from "../src/js/components/contactform";
import initGalleries from "../src/js/components/spotlight";
import fixEmptyElements from "../src/js/components/fixEmpty";
import initFeaturesGalleries from "../src/js/components/featuresgallery";
import initVideoCTA from "../src/js/components/video-cta";

const initParallaxes = () => {
  const initParallax = element => {
    const imgElement = element.querySelector("img");
    if (!imgElement || !$(element).parallax) return;

    let imageSrc = imgElement.getAttribute("data-src") || imgElement.getAttribute("src");
    element.removeChild(imgElement);
    element.parentNode.style.background = "transparent";
    $(element).parallax({ imageSrc });
  };

  const elements = document.querySelectorAll(".with-parallax .ptw-background");
  if (elements) {
    Array.prototype.forEach.call(elements, element => initParallax(element));
  }
};

if (!hasClass("body", "wp-admin")) {
  fixEmptyElements();
  initFeaturesGalleries();

  const onDocumentLoaded = () => {
    Console.log("Pantoda Studio");
    initLozad();
    initContactForms();
    initGalleries();
    initVideoCTA();
    initParallaxes();
    addClass("body", "page-loaded");
  };

  addElementEvents(document, ["DOMContentLoaded"], onDocumentLoaded);
}
